/* eslint-disable */

import App from '@/AppTemplate.vue'
import LoginComponent from '@/components/Login/Login.vue'
import restifyRoutes from './restifyRoutes'

// Rutas hijas de App: cargadas bajo demanda (una sola vez, no bloquean el login).
// App y LoginComponent quedan estáticos: son necesarios en el primer render.
const NewHome = () => import(/* webpackChunkName: "home" */ '@/components/NewHome/NewHome.vue')
const ProfileComponent = () => import(/* webpackChunkName: "profile" */ '@/components/Profile/Profile.vue')
const RastreoComponent = () => import(/* webpackChunkName: "rastreo" */ '@/components/Rastreo/Rastreo.vue')
const CotizarComponent = () => import(/* webpackChunkName: "cotizar" */ '@/components/CotizarNMT/Cotizar.vue')
const SolicitarRecogidaComponent = () => import(/* webpackChunkName: "solicitar-recogida" */ '@/components/SolicitarRecogida/SolicitarRecogida.vue')
const ConsultarSolicitudRecogida = () => import(/* webpackChunkName: "consultar-solicitud-recogida" */ '@/components/ConsultarSolicitudRecogida/ConsultarSolicitudRecogida.vue')
const LogisticaInversa = () => import(/* webpackChunkName: "logistica-inversa" */ '@/components/LogisticaInversa/LogisticaInversa.vue')
const Novedades = () => import(/* webpackChunkName: "novedades" */ '@/components/Novedades/Novedades.vue')
const ResetPassword = () => import(/* webpackChunkName: "reset-password" */ '@/components/RecoverPassword/ResetPassword.vue')
// indicadores //
const IndicadoresCourrier = () => import(/* webpackChunkName: "indicadores-courrier" */ '@/components/IndicadoresCourrier/IndicadoresCourrier.vue')
const Recogidas = () => import(/* webpackChunkName: "recogidas" */ '@/components/Recogidas/Recogidas.vue')
const InformeDeRastreo = () => import(/* webpackChunkName: "informe-rastreo" */ '@/components/InformeDeRastreo/InformeDeRastreo.vue')
const GestionNovedades = () => import(/* webpackChunkName: "gestion-novedades" */ '@/components/GestionNovedades/GestionNovedades.vue')
const Contacto = () => import(/* webpackChunkName: "contacto" */ '@/components/Contacto/Contacto.vue')
const RotulosDespacho = () => import(/* webpackChunkName: "rotulos-despacho" */ '@/components/RotulosDespacho/RotulosDespacho.vue')
const GeneracionGuias = () => import(/* webpackChunkName: "generacion-guias" */ '@/components/GeneracionGuias/GeneracionGuias.vue')
const Tutorial = () => import(/* webpackChunkName: "tutorial" */ '@/components/Tutorial/Tutorial.vue')
const Anulaciones = () => import(/* webpackChunkName: "anulaciones" */ '@/components/Anulaciones/Anulaciones.vue')
const Faq = () => import(/* webpackChunkName: "faq" */ '@/components/FAQ/FAQ.vue')
const ConsultShipping = () => import(/* webpackChunkName: "consult-shipping" */ '@/components/ConsultShipping/ConsultShipping.vue')
const TiemposEntrega = () => import(/* webpackChunkName: "tiempos-entrega" */ '@/components/TiemposEntrega/TiemposEntrega.vue')
const RecaudosInscripcion = () => import(/* webpackChunkName: "recaudos-inscripcion" */ '@/components/RecaudosInscripcion/RecaudosInscripcion.vue')
const RecaudosMisPagos = () => import(/* webpackChunkName: "recaudos-mis-pagos" */ '@/components/RecaudosMisPagos/RecaudosMisPagos.vue')
const AdministracionUsuarios = () => import(/* webpackChunkName: "administracion-usuarios" */ '@/components/AdministracionUsuarios/AdministracionUsuarios.vue')
const Misfacturas = () => import(/* webpackChunkName: "facturas" */ '@/components/Facturas/Facturas.vue')
const Configuration = () => import(/* webpackChunkName: "configuration" */ '@/components/configuration/Configuration.vue')
const Noticias = () => import(/* webpackChunkName: "noticias" */ '@/components/Noticias/Noticias.vue')
const NoticiaDetalle = () => import(/* webpackChunkName: "noticia-detalle" */ '@/components/NoticiaDetalle/NoticiaDetalle.vue')

const storage = JSON.parse(localStorage.getItem('vuex'));

const routes = [
    {
        path: '/',
        component: App,
        redirect: '/home',
        name: 'initial',
        children: [
            { path: 'home', component: NewHome, name: 'home' },
            { path: 'profile', component: ProfileComponent, name: 'profile', props: true },
            { path: 'rastreo', component: RastreoComponent, name: 'rastreo', props: true },
            { path: 'gestionnovedades', component: GestionNovedades, name: 'gestionnovedades' },
            { path: 'novedades', component: Novedades, name: 'novedades', props: true },
            { path: 'cotizar', component: CotizarComponent, name: 'cotizar', props: true },
            { path: 'estimacionenvios', component: ConsultShipping, name: 'estimacionenvios' },
            { path: 'logisticainversa', component: LogisticaInversa, name: 'logisticainversaredirect', props: true },
            { path: 'generarguia', component: LogisticaInversa, name: 'logisticainversa', props: true },
            { path: 'solicitarrecogida', component: SolicitarRecogidaComponent, name: 'solicitarrecogida' },
            { path: 'consultasolicitudrecogida', component: ConsultarSolicitudRecogida, name: 'consultasolicitudrecogida' },
            // { path: 'recoverypassword', component: ResetPassword, name: 'recoverypassword' },
            { path: 'indicadores', component: IndicadoresCourrier, name: 'indicadores' },
            { path: 'recogidas', component: Recogidas, name: 'recogidas' },
            // { path: 'reofrecimientos', component: Reofrecimientos, name: 'reofrecimientos' },
            { path: 'informerastreo', component: InformeDeRastreo, name: 'informerastreo' },
            { path: 'contacto', component: Contacto, name: 'contacto' },
            { path: 'rotulosdespacho', component: RotulosDespacho, name: 'rotulosdespacho' },
            { path: 'generacionguias', component: GeneracionGuias, name: 'generacionguias' },
            { path: 'tutorial', component: Tutorial, name: 'tutorial' },
            { path: 'preguntas-frecuentes', component: Faq, name: 'preguntas-frecuentes' },
            { path: 'anulaciones', component: Anulaciones, name: 'anulaciones' },
            { path: 'tiempos-de-entrega', component: TiemposEntrega, name: 'tiempos-de-entrega' },
            { path: 'mispagos', component: RecaudosMisPagos, name: 'mispagos' },
            { path: 'inscripcionrecaudo', component: RecaudosInscripcion, name: 'inscripcionrecaudo' },
            { path: 'administracion-usuarios', component: AdministracionUsuarios, name: 'administracion-usuarios' },
            { path: 'mis-facturas', component: Misfacturas, name: 'mis-facturas' },
            { path: 'configuration', component: Configuration, name: 'configuration' },
            { path: 'noticias', component: Noticias, name: 'noticias' },
            { path: 'noticias/:id', component: NoticiaDetalle, name: 'noticia-detalle', props: true },
        ]
    },
    { 'path': '/login', component: LoginComponent, name: 'login' },
    { path: '/recoverypassword', component: ResetPassword, name: 'recoverypassword' },
    { 'path': '*', redirect: '/login', }
]

const apiHost = process.env.VUE_APP_API_URL

const apiRoutes = restifyRoutes

export { apiHost, apiRoutes }
export default routes
